import { createContext } from "react";
import { SupabaseClient } from "@supabase/supabase-js";
import { createApi } from "./api";

export const ApiProviderContext = createContext<{
  api: ReturnType<typeof createApi>;
  supabase: SupabaseClient;
} | null>(null);

